import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getTypeColor } from "../../../constants/colors";

/**
 * ContentLockOverlay
 *
 * props:
 * - top: オーバーレイ開始位置
 * - type: "project" or "job"
 * - message: メッセージ
 */

const ContentLockOverlay = ({ top = 0, type = "project" }) => {
  const navigate = useNavigate();

  //パスを決定
  const redirectPath =
    type === "job" ? "/user_job_request/edit" : "/user_contract_request/edit";

  // job/project 用の共通設定
  const color = getTypeColor(type);

  return (
    <Box
      sx={{
        position: "absolute",
        top: {
          xs: `${top + 30}px`,
          sm: `${top}px`,
        },
        left: 0,
        right: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start",
        pt: 6,
        zIndex: 10,
        px: 2,
      }}
    >
      <Paper
        elevation={6}
        sx={{
          p: 3,
          borderRadius: 3,
          textAlign: "center",
          background: "white",
          width: "100%",
        }}
      >
        <Box
          onClick={() => {
            navigate(`${redirectPath}?redirect=${window.location.pathname}`);
            window.scrollTo({ top: 0, behavior: "auto" });
          }}
          sx={{
            background: color,
            color: "#fff",
            py: 1,
            px: 4,
            borderRadius: "24px",
            fontWeight: "bold",
            cursor: "pointer",
            boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
            display: "inline-flex",
            flexDirection: "column",
            fontSize: {
              xs: "0.8rem",
              sm: "0.9rem",
            },
            "&:hover": { opacity: 0.9 },
          }}
        >
          {"30秒で完了！"}
          <Box component="span" sx={{ display: { xs: "block", sm: "none" } }} />
          {"希望条件を入力"}
        </Box>

        <Typography
          sx={{
            whiteSpace: "pre-line",
            mt: 2,
            fontSize: {
              xs: "0.6rem",
              sm: "0.85rem",
            },
          }}
        >
          {"希望条件を入力すると"}
          <Box component="span" sx={{ display: { xs: "block", sm: "none" } }} />
          {"詳細を全て閲覧できます。"}
        </Typography>
      </Paper>
    </Box>
  );
};

export default ContentLockOverlay;
